// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1tvei","head":"Table_head__bTSN-","col":"Table_col__3s2va"};